export default defineNuxtRouteMiddleware((to, from) => {
  // Only run on client side
  if (process.server) return

  try {
    const { trackPageView, track } = usePostHog()

    // Track page navigation
    trackPageView(to.fullPath)

    // Track navigation patterns for UX insights
    if (from && from.fullPath !== to.fullPath) {
      track('page_navigation', {
        from_page: from.fullPath,
        to_page: to.fullPath,
        navigation_type: 'internal',
        route_name: to.name,
        query_params: Object.keys(to.query).length > 0 ? to.query : undefined,
      })
    }

    // Track specific business-critical pages
    if (to.path.includes('/plans')) {
      track('viewed_plans_page', {
        page_path: to.fullPath,
        plan_category: to.query.category || 'all',
      })
    }

    if (to.path.includes('/checkout')) {
      track('viewed_checkout_page', {
        page_path: to.fullPath,
        checkout_step: to.query.step || 'initial',
      })
    }

    if (to.path.includes('/account')) {
      track('viewed_account_page', {
        page_path: to.fullPath,
        account_section: to.path.split('/').pop() || 'overview',
      })
    }

  } catch (error) {
    console.warn('[PostHog Middleware] Failed to track page view:', error)
  }
})
